import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

interface NarRpaTriggerPayload {
  identifier: string;
}

export const narRpaTrigger = async (payload: NarRpaTriggerPayload) => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }
    const response = await fetch(API_ENDPOINTS.NAR_RPA_TRIGGER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    logDataToConsole("error in narRpaTrigger", error);
    throw error;
  }
};
